// src/arac-takip/src/components/Navbar.js
import "./Navbar.css";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { endSessionNow } from "../../../common/security/session";
import { buildAracTakipAccess } from "../utils/permissions";

const Navbar = () => {
  const { user, role, userPermissions, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const access = buildAracTakipAccess(role, userPermissions);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".navbar")) setMenuOpen(false);
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const handleLogout = async () => {
    try {
      await endSessionNow();
      await logout();
      navigate("/");
    } catch (e) {
      console.error("Çıkış sırasında hata:", e);
      navigate("/");
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src="/logo.png" alt="logo" className="navbar-logo" />
        <span className="navbar-title">Araç Takip Sistemi</span>
      </div>

      {user && (
        <>
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span></span><span></span><span></span>
          </div>
          <div className={`navbar-links ${menuOpen ? "show" : ""}`}>
            {access.canAdmin && (
              <NavLink className="navbar-link" to="/arac-takip/admin">Admin</NavLink>
            )}
            {access.canAdd && (
              <NavLink className="navbar-link" to="/arac-takip/add-issue">Eksiklik Ekle</NavLink>
            )}
            {access.canView && (
              <NavLink className="navbar-link" to="/arac-takip/view-issues">Eksiklikler</NavLink>
            )}
            {access.canResolved && (
              <NavLink className="navbar-link" to="/arac-takip/resolved-issues">Çözülenler</NavLink>
            )}
            {access.canStats && (
              <NavLink className="navbar-link" to="/arac-takip/istatistikler">İstatistikler</NavLink>
            )}
            {access.canLogs && (
              <NavLink className="navbar-link" to="/arac-takip/giris-loglari">Giriş Logları</NavLink>
            )}
            {access.canThreat && (
              <NavLink className="navbar-link" to="/arac-takip/tehdit-listesi">Tehdit Listesi</NavLink>
            )}
            {access.canTermin && (
              <NavLink className="navbar-link" to="/arac-takip/termin-assign">Termin Atama</NavLink>
            )}
            <NavLink className="navbar-link" to="/secilen-proje">Proje Seç</NavLink>
            <button className="logout-button" onClick={handleLogout}>Çıkış</button>
          </div>
        </>
      )}
    </nav>
  );
};

export default Navbar;
